var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGiftCard = function SvgGiftCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 48 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Gift card icon@3x")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,18 L18,18 L18,22 L18.0048953,22.1996403 C18.1089211,24.3160315 19.8578046,26 22,26 C24.209139,26 26,24.209139 26,22 C26,19.790861 24.209139,18 22,18 L22,18 Z M16,18 L12,18 L11.8003597,18.0048953 C9.68396847,18.1089211 8,19.8578046 8,22 C8,24.209139 9.790861,26 12,26 C14.209139,26 16,24.209139 16,22 L16,22 L16,18 Z M0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 L16,0 L16,8 L18,8 L18,0 L40,0 C44.418278,-8.11624501e-16 48,3.581722 48,8 L48,16 L26,16 L26,18 L48,18 L48,28 C48,32.418278 44.418278,36 40,36 L18,36 L18,26 L16,26 L16,36 L8,36 C3.581722,36 5.41083001e-16,32.418278 0,28 L0,18 L8,18 L8,16 L0,16 L0,8 Z M12,8 C9.790861,8 8,9.790861 8,12 C8,14.209139 9.790861,16 12,16 L12,16 L16,16 L16,12 L15.9951047,11.8003597 C15.8910789,9.68396847 14.1421954,8 12,8 Z M22,8 C19.790861,8 18,9.790861 18,12 L18,12 L18,16 L21.8703243,16 L21.8703243,16 L22,16 C24.209139,16 26,14.209139 26,12 C26,9.790861 24.209139,8 22,8 Z",
    id: "Gift-card-icon",
    fill: "#999999"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGiftCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gift-card.808ac1e6.svg";
export { ForwardRef as ReactComponent };